import { Component, OnInit } from '@angular/core';
import { CarouselComponent } from './carousel/carousel.component';
import { ContactUsFormComponent } from './contact-us-form/contact-us-form.component';
import { DialogModule } from 'primeng/dialog';

@Component({
    standalone: true,
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.less'],
    imports: [CarouselComponent, ContactUsFormComponent, DialogModule],
})
export class ContactUsComponent {
    displaySuccessDialog = false;
    showSuccessDialog() {
        this.displaySuccessDialog = true;
    }
}
